import type { Html } from "@scripts/codecs/html";

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const coerceHtmlAsString = (h: Html): string => h as unknown as string;
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const coerceStringAsHtml = (s: string): Html => s as unknown as Html;
